import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'atoms';

export default function NoData({ children }) {
	return (
		<Text textAlign="center" fontWeight="500" my="3rem">
			{children}
		</Text>
	);
}

NoData.propTypes = {
	children: PropTypes.node,
};
